module.exports = __webpack_public_path__ + "img/xhr.8413001c.jpg";